import formatWebsiteForDisplay from 'utils/formatWebsiteForDisplay';
import BaseInput from 'shared/Forms/Inputs/BaseInput';
import React from 'react';
import CopyToClipboard from 'shared/Links/CopyToClipboard';
import OpenInNewTab from 'shared/Links/OpenInNewTab';
import { translate } from 'App/Internationalization';

/**
 * @typedef {Readonly<{
 *  className: string,
 *  copyToClipboard: boolean,
 *  disabled: boolean,
 *  name: string,
 *  openInNewTab: boolean,
 *  placeholder: string,
 *  required: boolean,
 * }>} Props
 */

/**
 * @template Values
 * @typedef {import('formik').FormikProps<Values>} FormikProps
 */

/** @extends {React.Component<Props>} */
export default class InputWebsite extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.state = { isCopied: false, url: '' };
		/** @type {ReturnType<typeof setTimeout> | null} */
		this.copyResetTimeout = null;
		this.handleBlur = this.handleBlur.bind(this);
		this.handleCopySuccess = this.handleCopySuccess.bind(this);
		this.formatValue = this.formatValue.bind(this);
	}

	componentWillUnmount() {
		if (this.copyResetTimeout) {
			clearTimeout(this.copyResetTimeout);
		}
	}

	/** @returns {void} */
	handleCopySuccess() {
		if (this.copyResetTimeout) {
			clearTimeout(this.copyResetTimeout);
		}

		this.setState({ isCopied: true });

		this.copyResetTimeout = setTimeout(() => {
			this.setState({ isCopied: false });
		}, 2000);
	}

	/**
	 * TODO: This is a hacky way to update state on child component load
	 * 		 is there a better way to do this?
	 * @param {string} value
	 * @returns {string}
	 */
	formatValue(value) {
		if (!value) {
			return '';
		}

		const url = formatWebsiteForDisplay(value);
		this.setState({ isCopied: false, url });

		return url;
	}

	/**
	 * @template Values
	 * @param {React.FocusEvent<HTMLInputElement>} event
	 * @param {FormikProps<Values>} formikProps
	 */
	handleBlur(event, formikProps) {
		const { name, value } = event.target;
		const url = formatWebsiteForDisplay(value);

		formikProps.setFieldValue(name, url);
		formikProps.handleBlur(event);

		this.setState({ isCopied: false, url });
	}

	render() {
		return (
			<div className="input-website-area">
				<BaseInput
					autocomplete="url"
					className={this.props.className}
					disabled={this.props.disabled}
					formatValue={this.formatValue}
					name={this.props.name}
					onBlur={this.handleBlur}
					placeholder={this.props.placeholder}
					required={this.props.required}
					type="url"
				/>

				<div className="button-group mt-2">
					{this.props.copyToClipboard ? (
						<CopyToClipboard
							onSuccess={this.handleCopySuccess}
							text={translate(
								this.state.isCopied
									? 'global.links.copied'
									: 'global.links.copy'
							)}
							url={this.state.url}
						/>
					) : (
						''
					)}
					{this.props.openInNewTab ? (
						<OpenInNewTab url={this.state.url} />
					) : (
						''
					)}
				</div>
			</div>
		);
	}
}

InputWebsite.defaultProps = {
	className: '',
	copyToClipboard: true,
	disabled: false,
	name: '',
	openInNewTab: true,
	placeholder: '',
	required: false,
};
